import { render, staticRenderFns } from "./SurveyList.vue?vue&type=template&id=68a1d63e&scoped=true&"
import script from "./SurveyList.vue?vue&type=script&lang=js&"
export * from "./SurveyList.vue?vue&type=script&lang=js&"
import style0 from "./SurveyList.vue?vue&type=style&index=0&id=68a1d63e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a1d63e",
  null
  
)

export default component.exports